var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoAtlas32 = function SvgLogoAtlas32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 12v3h-.5A3.5 3.5 0 0 0 0 18.5v2A3.5 3.5 0 0 0 3.5 24H4v2.5A3.5 3.5 0 0 0 7.5 30h2a3.5 3.5 0 0 0 3.5-3.5V24h6v2.5a3.5 3.5 0 0 0 3.5 3.5h2a3.5 3.5 0 0 0 3.5-3.5V24h.5a3.5 3.5 0 0 0 3.5-3.5v-2a3.5 3.5 0 0 0-3.5-3.5H28v-3c0-6.627-5.373-12-12-12S4 5.373 4 12m12-3a3 3 0 0 0-3 3v3h6v-3a3 3 0 0 0-3-3m-6 3v3H7v-3a9 9 0 1 1 18 0v3h-3v-3a6 6 0 0 0-12 0m18.5 6a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-25a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zM7 26.5V24h3v2.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5m15 0V24h3v2.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgLogoAtlas32;